import { type FC } from 'react'
import { FormattedMessage } from 'react-intl'

import { type UserOrderResponseWithFlags } from '@redteclab/api/clients/bully'

import { useGetExperiment } from '../../experiments/hooks'
import { EXPERIMENT_NAME_HELP_CENTER_SELF_SERVICES } from '../../experiments/model/EXPERIMENT_NAME'
import { EXPERIMENT_VARIATION } from '../../experiments/model/EXPERIMENT_VARIATION'
import { useGlobalConfigContext } from '../../global-config'
import {
  urlResolverGetAccountOrders,
  urlResolverGetHelpCentrePharmaPage,
  urlResolverGetOrderQuestion,
  urlResolverGetOtherTopicsContactPage,
} from '../../url-handling'

import { ContactPageAccountCta } from './ContactPageAccountCta'
import { ContactPageFlatCta } from './ContactPageFlatCta'
import { ContactPageInvoicesAndDocumentsCta } from './ContactPageInvoicesAndDocumentsCta'

export const ContactPageCtaList: FC<{
  handleLoginModalOpen: () => void
  isUserLoggedIn: boolean
  maxOrders: number
  orders?: UserOrderResponseWithFlags[]
}> = ({ handleLoginModalOpen, isUserLoggedIn, maxOrders, orders }) => {
  const globalConfig = useGlobalConfigContext()
  const orderQuestionFlowExperiment =
    useGetExperiment(EXPERIMENT_NAME_HELP_CENTER_SELF_SERVICES).variant ===
    EXPERIMENT_VARIATION.V1

  return (
    <div className="mt-6 grid grid-cols-1 gap-x-4 gap-y-6 tablet:mt-0 tablet:grid-cols-2 tablet:gap-6">
      {isUserLoggedIn && orders && orders.length > maxOrders ? (
        <ContactPageFlatCta<'a'>
          data-qa-id="qa-id-orders-section-cta-orders"
          href={
            orderQuestionFlowExperiment
              ? urlResolverGetOrderQuestion(globalConfig)
              : urlResolverGetAccountOrders(globalConfig)
          }
          id="orders-section-cta-login"
        >
          <FormattedMessage id="contact.ordersSection.cta.label" />
        </ContactPageFlatCta>
      ) : null}
      {!isUserLoggedIn && (
        <ContactPageFlatCta
          data-qa-id="qa-id-help-center-login"
          onClick={handleLoginModalOpen}
        >
          <FormattedMessage id="helpCenter.option.login.dialog" />
        </ContactPageFlatCta>
      )}
      {orderQuestionFlowExperiment ? (
        <ContactPageInvoicesAndDocumentsCta isUserLoggedIn={isUserLoggedIn} />
      ) : null}

      <ContactPageAccountCta isUserLoggedIn={isUserLoggedIn} />
      <ContactPageFlatCta<'a'>
        data-qa-id="qa-id-help-center-pharma-page"
        href={urlResolverGetHelpCentrePharmaPage(globalConfig)}
      >
        <FormattedMessage id="contactForm.select.item.consultation" />
      </ContactPageFlatCta>
      <ContactPageFlatCta<'a'>
        data-qa-id="qa-id-help-center-other-topics-page"
        href={urlResolverGetOtherTopicsContactPage(globalConfig)}
      >
        <FormattedMessage id="helpCenter.option.other.page" />
      </ContactPageFlatCta>
    </div>
  )
}
